import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Downloads } from "./components/downloads";
import { About } from "./components/about";
import { Trailer } from "./components/trailer";
import { Streamers } from "./components/streamers";
import { Support } from "./components/support";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import {Footer} from "./components/footer";
import LanguageSelector from "./components/LanguageSelector";
import Terms from "./components/terms";
import Policy from "./components/Policy";
import {PinPayment} from "./components/PinPayment";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {

    const [isTermsOpen, setIsTermsOpen] = useState(false);

    const openTerms = () => setIsTermsOpen(true);
    const closeTerms = () => setIsTermsOpen(false);

    const [isPolOpen, setIsPolOpen] = useState(false);

    const openPol = () => setIsPolOpen(true);
    const closePol = () => setIsPolOpen(false);

    const handleOpenTerms = () => setIsTermsOpen(true);
    const handleCloseTerms = () => setIsTermsOpen(false);
    //const [fileURL, setfileURL] = useState("https://legend.mu/data/");
    const [fileURL, setfileURL] = useState("/data/");
  const [landingPageData, setLandingPageData] = useState({});
  const [language, setLanguage] = useState('data_en.json'); // Idioma por defecto
    const [languages, setLanguages] = useState([]);
    const [downloadLinks, setDownloadLinks] = useState([]);
    const [supportData, setsupportData] = useState([]);
    const [streamersData, setstreamersData] = useState([]);

    useEffect(() => {
        fetchDataJson();
    }, []);

    useEffect(() => {
        if (language) {
            fetchLanguageData(language);
        }
    }, [language]);



    const fetchDataJson = async () => {
        const cacheKey = 'dataJson';
        const cacheExpiryKey = `${cacheKey}_expiry`;
        const cachedData = localStorage.getItem(cacheKey);
        const cacheExpiry = localStorage.getItem(cacheExpiryKey);

        // Verificar si el cache ha expirado o no existe
        if (cachedData && cacheExpiry && new Date().getTime() < cacheExpiry) {
            const data = JSON.parse(cachedData);
            setLanguages(data.languages);
            setDownloadLinks(data.downloads);

            setstreamersData(data.streamers);
            setsupportData(data.support);
        } else {
            try {
                const response = await fetch(fileURL + '/data.json');
                const data = await response.json();
                setLanguages(data.languages);
                setDownloadLinks(data.downloads);
                setsupportData(data.support);
                setstreamersData(data.streamers);

                // Almacenar en cache con un tiempo de expiración de 10 minutos
                localStorage.setItem(cacheKey, JSON.stringify(data));
                localStorage.setItem(cacheExpiryKey, new Date().getTime() + 10 * 60 * 1000);
            } catch (error) {
                console.error('Error loading data.json:', error);
            }
        }
    };

    const fetchLanguageData = async (file) => {
        const cacheKey = `languageData_${file}`;
        const cachedData = localStorage.getItem(cacheKey);
        const cacheExpiry = localStorage.getItem(`${cacheKey}_expiry`);

        // Verificar si el cache ha expirado o no existe
        if (cachedData && cacheExpiry && new Date().getTime() < cacheExpiry) {
            setLandingPageData(JSON.parse(cachedData));
        } else {
            try {
                const response = await fetch(`${fileURL}/${file}`);
                const data = await response.json();
                setLandingPageData(data);
                // Almacenar en cache con un tiempo de expiración de 10 minutos
                localStorage.setItem(cacheKey, JSON.stringify(data));
                localStorage.setItem(`${cacheKey}_expiry`, new Date().getTime() + 10 * 60 * 1000);
            } catch (error) {
                console.error('Error loading language data:', error);
            }
        }
    };

    const handleLanguageChange = (event) => {
        setLanguage(event.file);
    };


    const TermsModal = ({ isOpen, onClose }) => {
        if (!isOpen) return null;

        return (
            <div style={modalStyles.overlay}>
                <div style={modalStyles.content}>
                    <h2>Terms of Service</h2>
                    <p>
                        [Aquí pega el contenido de los Términos de Servicio]
                    </p>
                    <button onClick={onClose} style={modalStyles.closeButton}>Close</button>
                </div>
            </div>
        );
    };

    const modalStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
        },
        content: {
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            width: "80%",
            maxWidth: "600px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        },
        closeButton: {
            marginTop: "20px",
            padding: "10px 20px",
            backgroundColor: "blue",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
        },
    };

    const termsHtml = `<div class="legal">\n           \n            <p>\n                These Terms of Service (this “Agreement”) apply to:\n            </p>\n            <ul>\n                <li>\n                    (a) Your downloading, installing, and/or using any of our games,\n                    including any connected software or services, any documentation\n                    relating to the use of any of our games, and any Updates we may make\n                    available to you for any of our games (collectively, the “Software”);\n                </li>\n                <li>\n                    (b) Your access to services that are made available by us in relation\n                    to the Software (the “Services”); and\n                </li>\n                <li>\n                    (c) Any text, images, graphics, photos, sounds, music, videos, audio-visual\n                    combinations, interactive content, and any other media, content, or\n                    information that may be made available to you through the Software or\n                    any of our Services (together, the “Content”).\n                </li>\n            </ul>\n            <p>\n                The Software, Services, and Content together are referred to as the\n                “Licensed Items.”\n            </p>\n\n            <h2>1. Acceptance of Terms</h2>\n            <p>\n                By installing or using the Licensed Items, you agree that you may only\n                install or use the Licensed Items:\n            </p>\n            <ul>\n                <li>(a) If you agree to this Agreement;</li>\n                <li>\n                    (b) If applicable laws and regulations permit you to use the Licensed\n                    Items where you are when you use them.\n                </li>\n            </ul>\n            <p>\n                If you do not agree to this Clause 1, do not install or use the Licensed\n                Items.\n            </p>\n\n            <h2>2. Changes to the Agreement</h2>\n            <p>\n                We may occasionally make changes to this Agreement. Please review it\n                from time to time. Any changes will become effective immediately upon\n                posting unless otherwise specified.\n            </p>\n\n            <h2>3. Additional Terms</h2>\n            <p>\n                In addition to this Agreement, there may be other terms and conditions\n                applicable to your use of the Licensed Items as notified by us from\n                time to time.\n            </p>\n\n            <h2>4. License to Use the Licensed Items</h2>\n            <p>\n                The Licensed Items are the property of Lemuria Legend and our licensors.\n                We grant you a limited, personal, non-exclusive, non-transferable,\n                royalty-free, and revocable license to:\n            </p>\n            <ul>\n                <li>(a) Use one copy of the Software in object code format only;</li>\n                <li>(b) Access and use the Services and Content in accordance with this Agreement.</li>\n            </ul>\n\n            <h2>5. Your Account</h2>\n            <p>\n                You may be required to open an account with Lemuria Legend to use the\n                Licensed Items. Your account is personal, and you are responsible for\n                safeguarding it.\n            </p>\n\n            <h2>6. Your Content</h2>\n            <p>\n                By submitting content in connection with the Licensed Items, you grant\n                us and our affiliates a perpetual, worldwide, royalty-free license to\n                use your content to provide and improve our services.\n            </p>\n\n            <h2>7. Restrictions on Use</h2>\n            <p>You may not:</p>\n            <ul>\n                <li>(a) Breach this Agreement or applicable laws;</li>\n                <li>(b) Use cheats, exploits, or unauthorized software;</li>\n                <li>(c) Reverse engineer or extract source code from the Licensed Items;</li>\n                <li>\n                    (d) Disrupt or interfere with the operation of the Licensed Items or\n                    the servers hosting them.\n                </li>\n            </ul>\n\n            <h2>8. Payments and Refunds</h2>\n            <p>\n                Payments made for Licensed Items are final and non-refundable unless\n                specified otherwise. Refunds for purchases made by EU residents are\n                subject to EU regulations and may be requested within 14 days of the\n                purchase date.\n            </p>\n\n            <h2>9. Infringement of Rights</h2>\n            <p>\n                If you believe your rights have been infringed, contact us at\n                info@dgamerstudio.com.\n            </p>\n\n            <h2>10. Open Source Software</h2>\n            <p>\n                Some Licensed Items may contain open-source software. In case of\n                conflict, the provisions of the open-source license will prevail.\n            </p>\n\n            <h2>11. Use of Your Device</h2>\n            <p>\n                Lemuria Legend may require access to your device to provide Licensed\n                Items. Personal information accessed will be treated in accordance with\n                our Privacy Policy.\n            </p>\n\n            <h2>12. Third-Party Content</h2>\n            <p>\n                We are not responsible for third-party content or services that may be\n                accessed through the Licensed Items.\n            </p>\n\n            <h2>13. Advertising</h2>\n            <p>\n                Advertising may be integrated into the Licensed Items. Targeted\n                advertising will comply with our Privacy Policy.\n            </p>\n\n            <h2>14. Warranty and Disclaimer</h2>\n            <p>\n                The Licensed Items are provided “as is.” We do not guarantee they will\n                be free of errors or compatible with your device.\n            </p>\n\n            <h2>15. Liability</h2>\n            <p>\n                Our total liability for claims is limited to the greater of USD 100 or\n                the amount paid by you in the preceding six months.\n            </p>\n\n            <h2>16. Termination</h2>\n            <p>\n                This Agreement applies until terminated. Upon termination, you must\n                delete all copies of the Licensed Items.\n            </p>\n\n            <h2>17. General</h2>\n            <p>\n                This Agreement constitutes the entire agreement between you and Lemuria\n                Legend. Any disputes will be resolved under the laws of the applicable\n                jurisdiction.\n            </p>\n\n            <h2>Contact</h2>\n            <p>\n                For questions or concerns, contact us at <a href="mailto:info@dgamerstudio.com">info@dgamerstudio.com</a>.\n            </p>\n        </div>`;
    const polHtml = `<div class="legal">
  
  <p>
    DGamerStudio (“DGamerStudio”) maintains this Privacy Statement (“Statement”) that summarizes our policies and processes for protecting all information gathered from customers, prospective customers, and visitors to our website(s) or who download and/or use DGamerStudio’s products and services that can be used to directly or indirectly identify an individual (“Personal Data”), and when and how Personal Data is collected, used, and safeguarded. This Statement also explains how anyone can review, update, correct, or delete Personal Data and specify what information, if any, they would like to receive from DGamerStudio on an ongoing basis.
  </p>

  <h2>Introduction</h2>
  <p>
    DGamerStudio is committed to ensuring your privacy and protecting the security of your personal information. This Policy covers the public DGamerStudio website located at 
    <a href="https://www.DGamerStudio.com" target="_blank" rel="noopener noreferrer">https://www.DGamerStudio.com</a> (the “Website”) and all online forms on the Website used to collect Personal Data.
  </p>
  <p>
    Please note that this Statement applies only to sites maintained by DGamerStudio or its affiliates, and not third-party sites, whether linked to or from the Website. Moreover, this Policy does not apply to information collected by DGamerStudio offline. In addition, this Policy does not apply to other entities that we do not own or control or persons that are not our employees, agents, or within our control.
  </p>
  <p>
    Any information stored by DGamerStudio is treated as confidential, and all information is stored securely and accessed only by authorized personnel. DGamerStudio maintains and implements appropriate technical, security, and organizational measures to protect Personal Data against unauthorized or unlawful processing, and against accidental theft or disclosure.
  </p>
  <p>
    By using the Website, you are agreeing to the terms and conditions of this Statement and that your use of the Website, including downloads/use of any of DGamerStudio’s products and services, is subject to DGamerStudio’s Terms of Service. If you do not agree with any terms or conditions described in this Statement or the Terms of Service, please exit from the Website.
  </p>

  <h2>Collecting Personal Information</h2>
  <p>
    You can access our Website without providing us with any personal information. However, DGamerStudio may collect personal information in various locations on our Website as more particularly described below. Our primary goal in collecting the information described below is to provide you, the user, with a customized experience on our Website and to deliver better service, products, and more relevant content to our customers, prospective customers, and visitors.
  </p>

  <h3>Personal Data We Collect</h3>
  <p>
    Personal information may be collected from you during (a) the registration process, (b) promotional campaigns, (c) customer support and technical service requests, and/or (d) ordering of products and other services from the Website or from third-party service providers. This information may include your name, address, phone number, email address, birth date, occupation, gender, account ID, passwords, and/or payment and billing information. We ask that you provide only your own personal information, not personal information concerning anyone else. Personal information may be collected by DGamerStudio and/or business partners such as co-sponsors.
  </p>

  <h3>Cookies</h3>
  <p>
    We use “Cookies,” which are text files stored on your computer for operational purposes, and to collect data to analyze user patterns to improve the browsing experience of our website. Cookies are only read by the server that placed them and cannot execute any code or virus. Control and access of information from first-party Cookies will not be shared with any other parties.
  </p>
  <ul>
    <li>
      Only non-personal information is stored and collected on an aggregated and anonymous basis from Cookies, and the use will be limited to one of the following cases:
      <ul>
        <li>To remember your settings and actions so that some of the entry fields or selections from our website can be automatically completed for your convenience.</li>
        <li>
          To gather anonymous statistics to analyze which videos were watched and/or which banners were clicked to make our site more useful and interesting to our users.
        </li>
        <li>For website operation-related purposes such as login authentication.</li>
      </ul>
    </li>
    <li>
      The types of Cookies used on our website are:
      <ul>
        <li>
          <b>Session Cookies:</b> Used for login authentication purposes and will be automatically deleted from your hard drive after closing your browser.
        </li>
        <li>
          <b>Persistent Cookies:</b> Used to remember your settings for a predefined duration and will be automatically deleted from your hard drive upon expiry.
        </li>
      </ul>
    </li>
    <li>
      There may be third-party server networks to serve advertisements within or in connection with our websites. Third-party companies can send their own cookies to your hard drive since your web browser must request such advertising banners from the third-party network servers. However, we only authorize third-party servers to employ anonymous cookies for anonymous targeting.
    </li>
  </ul>

  <h3>Log Files</h3>
  <p>
    Like most Internet services, we may also use log files on the server side. The data held in log files includes your IP (Internet Protocol) address, browser type, email application, Internet service provider, referring/exit Web pages, computer platform type, date/time stamp, and user activity. DGamerStudio uses server log data to analyze trends and administer the services offered through the Website. However, IP addresses are not tied to any personally identifiable information.
  </p>

  <h2>Monitoring / Public Information</h2>
  <p>
    When any game is updated or “patched,” our patch routine may check your computer to ensure you have the most recent version of game-specific files. When you communicate within any game or any other communication feature within the game (e.g., live chat or instant messaging), even privately to another person, those communications may go through our servers and can be monitored by us.
  </p>

  <h3>Use of Personal Information</h3>
  <p>
    DGamerStudio uses your information to:
  </p>
  <ul>
    <li>Register you for our services.</li>
    <li>Ensure smooth operation of our services.</li>
    <li>Analyze usage patterns for better marketing and product development.</li>
    <li>Communicate with you regarding your account, newsletters, or updates.</li>
  </ul>

  <h3>Retention and Deletion</h3>
  <p>
    DGamerStudio will not retain Personal Data longer than necessary. Upon account termination, your data will be deleted unless required by law to retain it.
  </p>

  <h3>Contact Us</h3>
  <p>
    For any questions, complaints, or comments, please contact us at <a href="mailto:info@dgamerstudio.com">info@dgamerstudio.com</a>.
  </p>
</div>`;
    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    <>
                        <Navigation data={landingPageData.Menu}>
                            <LanguageSelector onLanguageChange={handleLanguageChange} languages={languages} />
                        </Navigation>
                        <Header data={landingPageData.Header} />
                        <Downloads languageData={landingPageData.Downloads} downloadData={downloadLinks} />
                        <About data={landingPageData.About} />
                        <Trailer data={landingPageData.Trailer} />
                        <Streamers languageData={landingPageData.Streamers} streamerData={streamersData} />
                        <Support languageData={landingPageData.Support} supportData={supportData} />

                        <div style={{ textAlign: "center", margin: "20px 0" }}>
                            <button className="generic-button" onClick={() => setIsTermsOpen(true)}>Terms of Service</button>
                            <button className="generic-button" onClick={() => setIsPolOpen(true)}>Privacy Policy</button>
                        </div>

                        <Terms isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} htmlContent={termsHtml} />
                        <Policy isOpen={isPolOpen} onClose={() => setIsPolOpen(false)} htmlContent={polHtml} />
                        <Footer data={landingPageData.Footer} />
                    </>
                } />
                <Route path="/pinPayment" element={
                    <>
                        <Navigation data={landingPageData.Menu}>
                            <LanguageSelector onLanguageChange={handleLanguageChange} languages={languages} />
                        </Navigation>
                        <Header data={landingPageData.Header} small={true} />
                        <PinPayment />
                        <Footer data={landingPageData.Footer} />
                    </>
                } />
            </Routes>
        </Router>
    );
};


export default App;
